import { ConstraintRequiresTransactionVoucherInput, OfferFragment } from '@occc/graphql';
import { makeCreateRequiresTransactionVoucherConstraintOperation } from '@occc-app/offerHelpers/operations/constraints';
import { makeUpdateConstraint } from '@occc-app/offerHelpers/operations/updateConstraintOperation.utils';
import { Operation } from '@occc-app/offerHelpers/types';
import { constraintHelper } from '@occc-app/offerHelpers/utils/constraintHelper';

import { VoucherStackingFormValues } from './types';

export const getVoucherStackingConstraint = (offer: OfferFragment | null | undefined) => {
  return offer?.constraints.find(constraintHelper.isRequiresTransactionVoucher);
};

export const getVoucherStackingInitialValues = (
  offer: OfferFragment | null | undefined,
  isFuelRollbackVoucherStackingEnabled: boolean,
): VoucherStackingFormValues['voucherStackingConstraint'] => {
  const transactionVoucherConstraint = getVoucherStackingConstraint(offer);

  return {
    id: transactionVoucherConstraint?.id,
    isEnabled: isFuelRollbackVoucherStackingEnabled
      ? transactionVoucherConstraint?.allowSingleOfferVoucherStacking || false
      : false,
    breakageRefund: transactionVoucherConstraint?.breakageRefund || false,
    breakagePointRounding: transactionVoucherConstraint?.breakagePointRounding || null,
  };
};

export const getVoucherStackingConstraintOperations = (
  offerId: string,
  offer: OfferFragment | undefined,
  values: VoucherStackingFormValues,
): Operation[] => {
  const operations: Operation[] = [];

  const existingConstraintId = getVoucherStackingConstraint(offer)?.id;

  const constraintValues: ConstraintRequiresTransactionVoucherInput = {
    allowSingleOfferVoucherStacking: values?.voucherStackingConstraint?.isEnabled ?? false,
    breakageRefund: values?.voucherStackingConstraint?.breakageRefund ?? false,
    breakagePointRounding: values?.voucherStackingConstraint.breakagePointRounding ?? null,
  };

  if (existingConstraintId) {
    operations.push(
      makeUpdateConstraint(existingConstraintId, {
        requiresTransactionVoucherConstraintWithConfiguration: constraintValues,
      }),
    );
  } else {
    operations.push(
      makeCreateRequiresTransactionVoucherConstraintOperation(offerId, constraintValues),
    );
  }

  return operations;
};
